import React, { useState, useEffect, useCallback } from 'react';
import { hrAPI } from '../../services/api';
import { AuthImg, deptLabel } from './hrShared';

export default function HRTeam() {
  const [data, setData] = useState({ manager: null, directs: [], peers: [] });
  const [loading, setLoading] = useState(true);
  const [loadErr, setLoadErr] = useState(null); // V71 — hata "ekip bilgisi yok" gibi görünmesin

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await hrAPI.selfTeam();
      setData(r.data || {});
      setLoadErr(null);
    } catch (e) {
      // İK kaydı olmayan kullanıcı için sunucu 404 döner — boş ekip olarak gösterilir
      if (e.response?.status === 404) { setData({ manager: null, directs: [], peers: [] }); setLoadErr(null); }
      else setLoadErr(e.response?.data?.error || e.message || 'Ekip bilgisi yüklenemedi.');
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="loading-state">Yükleniyor…</div>;
  if (loadErr) {
    return (
      <div className="error-state">
        ⚠️ Ekip bilgisi yüklenemedi: {loadErr}
        <button className="btn btn-secondary btn-sm" onClick={load}>Tekrar dene</button>
      </div>
    );
  }

  return (
    <div>
      {data.manager && (
        <div className="hr-card">
          <h3 className="hr-card-title">⬆️ Yöneticim</h3>
          <PersonCard p={data.manager} />
        </div>
      )}

      {data.peers?.length > 0 && (
        <div className="hr-card">
          <h3 className="hr-card-title">👥 Ekip Arkadaşlarım ({data.peers.length})</h3>
          <div className="hr-person-grid">
            {data.peers.map(p => <PersonCard key={p.id} p={p} compact />)}
          </div>
        </div>
      )}

      {data.directs?.length > 0 && (
        <div className="hr-card">
          <h3 className="hr-card-title">⬇️ Yönettiğim Ekip ({data.directs.length})</h3>
          <div className="hr-person-grid">
            {data.directs.map(p => <PersonCard key={p.id} p={p} compact />)}
          </div>
        </div>
      )}

      {!data.manager && !data.peers?.length && !data.directs?.length && (
        <div className="hr-card hr-empty-card">
          <div className="hr-empty-ic">👥</div>
          <h3>Ekip bilgisi yok</h3>
          <p>Yöneticiniz veya altınızdaki çalışanlar henüz tanımlanmamış. İK'dan organizasyon ataması istenebilir.</p>
        </div>
      )}
    </div>
  );
}

function PersonCard({ p, compact }) {
  const initials = (p.name || '?').split(' ').map(s => s[0]).slice(0, 2).join('').toUpperCase();
  // V71 — fotoğraf token'lı çekilir (düz URL 401 alıyordu); departman etiketi tüm kodları tanır
  const photoPath = p.foto_path ? `/hr/self/photo/${p.foto_path.split('/').pop()}` : null;
  const dept = deptLabel(p);
  return (
    <div className={`hr-person${compact ? ' compact' : ''}`}>
      <AuthImg path={photoPath} className="hr-person-ava" alt="" fallback={<div className="hr-person-ava">{initials}</div>} />
      <div className="hr-person-meta">
        <div className="hr-person-name">{p.name}</div>
        <div className="hr-person-sub">
          {p.unvan || p.pozisyon || '—'}{dept && ` · ${dept}`}
        </div>
        {p.iletisim_email && <div className="hr-person-mail">{p.iletisim_email}</div>}
      </div>
    </div>
  );
}
